const GetToken = () => {
  let token = 'Bearer ';

  if(localStorage.getItem('secret_token') !== undefined && localStorage.getItem('secret_token') !== null) {
    token = token + localStorage.getItem('secret_token');

    return token;
  } else {
  	return false;
  }
}

export default GetToken;
